<template>
  <v-container class="pt-5 pb-1">
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="form.workstation"
          type="text"
          hide-details
          label="Nome"
          outlined
          dense
          @input="
            (v) => {
              form.workstation = v.toUpperCase()
            }
          "
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-btn dark color="primary" text @click="close()"> Sair </v-btn>
      <v-btn dark color="blue darken-1" @click="setSubmit()"> Salvar </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FormWorkstation',
  props: {
    closeDialog: {
      type: Function,
      default: () => {},
    },
    editData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      form: {
        workstation: null,
      },
    }
  },
  computed: {},
  watch: {
    editData: function () {
      if (this.editData.workstation != '') {
        this.form = { ...this.editData }
      } else {
        this.form = {}
      }
    },
  },
  mounted: function () {
    if (this.editData.workstation != '') {
      this.form = { ...this.editData }
    } else {
      this.form = {}
    }
  },
  methods: {
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('utils', ['ActionStoreWorkstation', 'ActionUpdateWorkstation']),
    async save() {
      if (this.form.workstation !== '') {
        this.ActionSetLoading(true)
        try {
          await this.ActionStoreWorkstation({ ...this.form })
          this.$swal({
            icon: 'success',
            title: 'Cadastrado',
            text: 'Vínculo cadastrada com sucesso',
          })
          this.close()
        } catch (error) {
          console.error(error)
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível cadastrar Vínculo.',
          })
        } finally {
          this.ActionSetLoading(false)
        }
      }
    },
    async update() {
      if (!this.form.workstation) {
        return
      } else {
        this.ActionSetLoading(true)
        try {
          await this.ActionUpdateWorkstation({ ...this.form })
          this.$swal({
            icon: 'success',
            title: 'Atualizado',
            text: 'Vínculo atualizada com sucesso.',
          })
          this.closeDialog()
        } catch (error) {
          console.error(error)
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível atualizar Vínculo.',
          })
        } finally {
          this.ActionSetLoading(false)
        }
      }
    },
    close() {
      this.closeDialog()
      this.form = {}
    },
    setSubmit() {
      if (!this.editData.workstation) {
        this.save()
      } else {
        this.update()
      }
    },
  },
}
</script>
